import styled from 'styled-components'

export const StyledSkipToContent = styled.div`
  height: 0;
  opacity: 0;
  color: #fff;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: height 0.3ms, opacity 0.3ms;
  ${({ theme }) => theme.paddingX(16)};
  background-color: ${({ theme }) => theme.colors.general.light()};

  :has(a:focus),
  :has(a:focus-within) {
    height: 36px;
    opacity: 1;
  }
`

export const StyledSkipToContentTrigger = styled.a`
  text-decoration: underline;
  padding: 0;
  ${({ theme }) => theme.typo('buttonSmall')};
  color: ${({ theme }) => theme.colors.grayscale.white};

  &:focus{
    border:none;
    outline: 2px solid ${({ theme }) => theme.colors.accent()};
    outline-offset: 2px;
  }
`
